import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=7b6ca84a&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"
import style0 from "./Modal.vue?vue&type=style&index=0&id=7b6ca84a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6ca84a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CookiesConsent: require('/home/ticketshoplv/public_html/ticketshop.lt/components/cookies/Consent.vue').default})
